import { OnInit, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MatSnackBar } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { ActivatedRoute, Router } from '@angular/router';
import { BulkHttpService } from '../../../core/bulk';
import { Cache } from 'aws-amplify';
import * as XLSX from 'xlsx';
import { MixpanelService } from '../../../services/mixpanel.service';
var BulkActionsComponent = /** @class */ (function () {
    function BulkActionsComponent(http, cdr, _snackBar, activatedRoute, router, mixpanelService) {
        this.http = http;
        this.cdr = cdr;
        this._snackBar = _snackBar;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.mixpanelService = mixpanelService;
        //   displayedColumns: string[] = ['select', 'machine_id', 'machine_name', 'ui_cv', 'aux_cv', 'menu_cv'];
        this.dataSource = new MatTableDataSource();
        this.fileName = "Version Report";
        this.selection = new SelectionModel(true, []);
        //   availableColumns: string[] = [ 'ui_cv','ui_av', 'aux_cv', 'aux_av', 'menu_cv', 'menu_av'];
        this.displayedColumns = ['select', 'machine_id', 'machine_name', 'ui_cv', 'aux_cv', 'menu_cv'];
        this.availableColumns = [{ value: 'ui_cv', key: 'UI (current version)' }, { value: 'aux_cv', key: 'VMC (current version)' },
            { value: 'menu_cv', key: 'MENU (current version)' }, { value: 'ui_av', key: 'UI (available version)' },
            { value: 'aux_av', key: 'VMC (available version)' }, { value: 'menu_av', key: 'MENU (available version)' }];
        this.showSettingsPanel = false;
        this.columnVisibility = {
            'ui_cv': true,
            'aux_cv': true,
            'menu_cv': true
        };
        this.selectedMacs = [];
        this.selRegion = '';
        this.selTerritory = '';
        this.versionTypes = [{ value: 'ui_cv', key: 'UI (current version)' }, { value: 'aux_cv', key: 'VMC (current version)' },
            { value: 'menu_cv', key: 'MENU (current version)' }, { value: 'ui_av', key: 'UI (available version)' },
            { value: 'aux_av', key: 'VMC (available version)' }, { value: 'menu_av', key: 'MENU (available version)' }];
        this.versionTypeOptions = [
            { value: '', label: 'All' },
            { value: 'ui_cv', label: 'UI (current version)' },
            { value: 'aux_cv', label: 'VMC (current version)' },
            { value: 'menu_cv', label: 'MENU (current version)' },
            { value: 'ui_av', label: 'UI (available version)' },
            { value: 'aux_av', label: 'VMC (available version)' },
            { value: 'menu_av', label: 'MENU (available version)' }
        ];
        this.selType = null;
        //   versions: any[] = [];
        this.versionOptions = [{ value: '', label: 'All' }];
        this.selVersion = null;
        this.actionOptions = [
            { value: 'update', label: 'S/W & F/W Updates' }
        ];
        this.selected = 1;
        this.selectedDisti = { disti_id: null };
        this.selectedClient = { client_id: null };
        this.selectedCampus = { campus_id: null };
        this.selectedMarket = { market_id: null };
        this.distiName = 'ALL';
        this.clientName = 'ALL';
        this.campusName = 'ALL';
        this.marketName = 'ALL';
        this.qParams = {};
        this.defaultParams = {
            noPerPg: 50,
            pgNo: 0,
            sortKey: 'serial_no',
            sortVal: 'asc',
            registered: true,
            optFilterKey: 'connectivity',
            optFilterVal: '',
            optFilterKey1: 'machine_status',
            optFilterVal1: '',
            txtFilterKey: 'location_name',
            txtFilterVal: '',
            disti_id: null,
            client_id: null,
            campus_id: null,
        };
    }
    BulkActionsComponent.prototype.toggleColumnVisibility = function (column) {
        var columnObject = this.availableColumns.find(function (col) { return col.key === column.key; });
        if (columnObject && columnObject.value !== 'machine_id' && columnObject.value !== 'machine_name') {
            this.columnVisibility[columnObject.value] = !this.columnVisibility[columnObject.value];
            this.refreshDisplayedColumns();
        }
    };
    BulkActionsComponent.prototype.refreshDisplayedColumns = function () {
        var fixedColumns = ['select', 'machine_id', 'machine_name'];
        var selectedColumns = [];
        for (var _i = 0, _a = this.availableColumns; _i < _a.length; _i++) {
            var col = _a[_i];
            if (this.columnVisibility[col.value]) {
                selectedColumns.push(col.value);
            }
        }
        this.displayedColumns = fixedColumns.concat(selectedColumns);
    };
    BulkActionsComponent.prototype.ngOnInit = function () {
        //   this.getRegions();
        this.user = Cache.getItem('userAttr');
        this.role = this.user['custom:role'];
        if (this.user['custom:disti_id'])
            this.selectedDisti = { disti_id: this.user['custom:disti_id'] };
        if (this.user['custom:client_id'])
            this.selectedClient = { client_id: this.user['custom:client_id'] };
        if (this.user['custom:campus_id'])
            this.selectedCampus = { campus_id: this.user['custom:campus_id'] };
        this.dataSource.paginator = this.paginator;
        this.getMachines();
        this.mixpanelService.track(this.mixpanelService.PAGE_VIEW);
    };
    BulkActionsComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.activatedRoute.queryParams.subscribe(function (params) {
            if (params.reset) {
                // console.log(params);
                _this.selection.clear();
                _this.selectedMacs = [];
                _this.router.navigate([], { queryParams: {} });
            }
            else {
            }
        });
        // if (this.activatedRoute.snapshot.paramMap.get('reset')) {
        // 	console.log(`this.activatedRoute.snapshot.paramMap.get('reset')`, this.activatedRoute.snapshot.paramMap.get('reset'));
        // 	this.selection.clear();
        // 	this.selectedMacs = [];
        // }
        console.log(this.router.url.search('reset'));
    };
    BulkActionsComponent.prototype.getMachines = function () {
        var _this = this;
        var selTypeValue = this.selType || '';
        var selVersionValue = this.selVersion || '';
        this.qParams = {
            noPerPg: this.paginator.pageSize || 50,
            pgNo: this.paginator.pageIndex || 0,
            sortKey: 'serial_no',
            sortVal: 'asc',
            registered: true,
            disti_id: this.selectedDisti ? this.selectedDisti.disti_id : null,
            client_id: this.selectedClient ? this.selectedClient.client_id : null,
            campus_id: this.selectedCampus ? this.selectedCampus.campus_id : null,
            market_id: this.selectedMarket ? this.selectedMarket.market_id : null,
            type: selTypeValue,
            version: selVersionValue
        };
        this.http.getAllVersions(this.qParams)
            .subscribe(function (machines) {
            // console.log(machines);
            _this.machines = machines;
            _this.dataSource.data = machines;
            console.log("Length:", _this.dataSource.data.length);
            // console.log("Datasource: ", this.dataSource);
            _this.cdr.detectChanges();
        });
    };
    BulkActionsComponent.prototype.onFiltersChange = function (params) {
        // Update selected entities from FilterParams
        var previousDistiId = this.selectedDisti ? this.selectedDisti.disti_id : null;
        if (params.disti_id) {
            var distiId = Array.isArray(params.disti_id) ? params.disti_id[0] : params.disti_id;
            this.selectedDisti = { disti_id: distiId };
            this.distiName = 'Selected'; // The hierarchical-filters component handles display
            // Reset dependent selections if distributor changed
            if (previousDistiId !== distiId) {
                this.selectedMarket = { market_id: null };
                this.marketName = 'ALL';
                this.selectedClient = { client_id: null };
                this.clientName = 'ALL';
                this.selectedCampus = { campus_id: null };
                this.campusName = 'ALL';
            }
        }
        else {
            this.selectedDisti = { disti_id: null };
            this.distiName = 'ALL';
        }
        if (params.market_id) {
            var marketId = Array.isArray(params.market_id) ? params.market_id[0] : params.market_id;
            this.selectedMarket = { market_id: marketId };
            this.marketName = 'Selected';
        }
        else {
            this.selectedMarket = { market_id: null };
            this.marketName = 'ALL';
        }
        if (params.client_id) {
            var clientId = Array.isArray(params.client_id) ? params.client_id[0] : params.client_id;
            this.selectedClient = { client_id: clientId };
            this.clientName = 'Selected';
            // Reset campus if client changed
            if (!params.campus_id) {
                this.selectedCampus = { campus_id: null };
                this.campusName = 'ALL';
            }
        }
        else {
            this.selectedClient = { client_id: null };
            this.clientName = 'ALL';
        }
        if (params.campus_id) {
            var campusId = Array.isArray(params.campus_id) ? params.campus_id[0] : params.campus_id;
            this.selectedCampus = { campus_id: campusId };
            this.campusName = 'Selected';
        }
        else {
            this.selectedCampus = { campus_id: null };
            this.campusName = 'ALL';
        }
        this.getMachines();
        this.cdr.detectChanges();
    };
    BulkActionsComponent.prototype.onOpt = function (event) {
        this.opt = event || '';
    };
    BulkActionsComponent.prototype.getRegions = function () {
        var _this = this;
        this.http.getRegions()
            .subscribe(function (regions) {
            _this.regions = regions;
        });
    };
    BulkActionsComponent.prototype.onType = function () {
        var _this = this;
        var selTypeValue = this.selType || '';
        var types = String(selTypeValue).split('_');
        this.http.getVersions({ type: types[0] })
            .subscribe(function (versions) {
            // console.log("Response:", versions);
            _this.selVersion = null;
            _this.versions = versions.data;
            _this.versionOptions = [
                { value: '', label: 'All' }
            ].concat(versions.data.map(function (v) { return ({ value: v.file_version, label: v.file_version }); }));
        });
        this.cdr.detectChanges();
    };
    BulkActionsComponent.prototype.onVersion = function () {
        this.cdr.detectChanges();
        this.getMachines();
    };
    BulkActionsComponent.prototype.exportExcel = function () {
        var data = this.dataSource.data;
        var columnsToExport = ['machine_id', 'machine_name', 'ui_cv', 'ui_av', 'aux_cv', 'aux_av', 'menu_cv', 'menu_av'];
        var filteredData = data.map(function (item) {
            var filteredItem = {};
            columnsToExport.forEach(function (col) {
                filteredItem[col] = item[col];
            });
            return filteredItem;
        });
        // Generate worksheet
        var ws = XLSX.utils.json_to_sheet(filteredData);
        // Generate workbook and add the worksheet
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Version');
        // Save to file
        XLSX.writeFile(wb, this.fileName + '.xlsx');
    };
    //   /** Whether the number of selected elements matches the total number of rows. */
    //   isAllSelected() {
    // 	const numSelected = this.selection.selected.length;
    // 	const numRows = this.dataSource.data.length;
    // 	return numSelected === numRows;
    //   }
    //   /** Selects all rows if they are not all selected; otherwise clear selection. */
    //   masterToggle() {
    // 	this.isAllSelected() ?
    // 	this.selection.clear() :
    // 	this.dataSource.data.forEach(row => this.selection.select(row));
    //   }
    //   /** The label for the checkbox on the passed row */
    //   checkboxLabel(row?: MachineStr): string {
    // 	  console.log(this.selection);
    // 	if (!row) {
    // 		return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    // 	}
    // 	return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
    //   }
    BulkActionsComponent.prototype.isAllSelected = function ($event) {
        var numSelected = this.selection.selected.length;
        var numRows = this.dataSource.data.length;
        return numSelected === numRows;
    };
    BulkActionsComponent.prototype.masterToggle = function ($event) {
        var _this = this;
        if ($event.checked) {
            this.onCompleteRow(this.dataSource);
        }
        this.isAllSelected($event) ?
            this.selection.clear() :
            this.dataSource.data.forEach(function (row) { return _this.selection.select(row); });
    };
    BulkActionsComponent.prototype.selectRow = function ($event, dataSource) {
        // console.log($event.checked);
        if ($event.checked) {
            this.selectedMacs.push(dataSource);
            //   this.selection.select(dataSource);
        }
        else {
            // this.selection.deselect(dataSource);
            var ind = this.selectedMacs.indexOf(dataSource);
            if (ind >= 0) {
                this.selectedMacs.splice(ind, 1);
            }
        }
        // console.log(this.selection.selected, this.selection.selected.length);
    };
    BulkActionsComponent.prototype.onCompleteRow = function (dataSource) {
        dataSource.data.forEach(function (element) {
            console.log(element.name);
        });
    };
    BulkActionsComponent.prototype.onNext = function () {
        console.log(this.selectedMacs);
        if (this.selection.isEmpty()) {
        }
        else {
            console.log(this.selection.selected);
        }
        //   if(this.selection.selected)
    };
    BulkActionsComponent.prototype.showSnackBar = function (message, duration) {
        var _this = this;
        var snackRef = this._snackBar.open(message, 'close');
        if (duration > 0) {
            setTimeout(function () {
                _this._snackBar.dismiss();
            }, duration);
        }
        snackRef.onAction().subscribe(function () {
            _this._snackBar.dismiss();
        });
    };
    return BulkActionsComponent;
}());
export { BulkActionsComponent };
